import { prompt, type PromptDefinition } from './models';

export const SAFETY_MANAGER_PROMPTS = [
    prompt(
        'Manage risk',
        'Which hazards and unresolved safety actions are documented for this building?',
        'Which buildings have the most urgent documented safety actions?'
    ),
    prompt(
        'Manage risk',
        'What incidents and near misses are recorded for this building?',
        'Compare documented incidents and near misses across my buildings.'
    ),
    prompt(
        'Manage risk',
        'What emergency response arrangements are recorded for this building?',
        'Which buildings need their emergency response records reviewed?'
    ),
    prompt(
        'Manage risk',
        'Find risk assessments for this building covering…',
        'Find risk assessments across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Manage risk',
        'Which safety controls in this building lack verification evidence?',
        'Which buildings have safety controls without evidence of verification?'
    ),
    prompt(
        'Manage risk',
        "What do this building's records say about evacuation drills and follow-up actions?",
        'Which buildings have overdue evacuation-drill follow-up actions in the records?'
    ),
    prompt(
        'Manage risk',
        'What training or induction gaps are documented for work in this building?',
        'Compare documented safety training and induction gaps across my buildings.'
    ),
    prompt(
        'Manage risk',
        'Find safety incident investigations for this building involving…',
        'Find safety incident investigations across my buildings involving…',
        'prefill'
    ),
    prompt(
        'Manage risk',
        'Which high-risk work activities require precautions in this building?',
        'Which buildings have high-risk work needing safety coordination?'
    ),
    prompt(
        'Manage risk',
        "What corrective actions followed this building's recent safety inspections?",
        'Which buildings have safety inspection actions without completion evidence?'
    ),
    prompt(
        'Manage risk',
        "Where are safety responsibilities unclear in this building's records?",
        'Which buildings have gaps in documented safety responsibilities?'
    ),
    prompt(
        'Manage risk',
        'Prepare a safety briefing for work in this building involving…',
        'Compare safety controls across my buildings for work involving…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
